import { useContext } from "react";
import { DensityContext } from "@/lib/density";

// Hook split out so consumers can `import { useDensity } from "@/hooks/..."`
// (matches the rest of the hooks/ folder) without pulling in the provider
// component and its React-tree dependencies just to read a value.
export function useDensity() {
  return useContext(DensityContext);
}
